import PropTypes from 'prop-types';

import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import Skeleton from '#client/components/Skeleton';
import empty from '#client/utils/empty';

import useStyles from './useStyles';

const fields = [
  {
    key: 'name',
    label: 'Name'
  },
  {
    key: 'phone',
    label: 'Phone'
  },
  {
    key: 'email',
    label: 'Email'
  },
  {
    key: 'password',
    label: 'Password'
  }
];

const formatName = (...props) => props
  .filter((val) => (!empty(val)))
  .map((val) => (val.trim()))
  .join(' ');

const AccountHolder = ({
  account: {
    firstName,
    middleName,
    lastName,
    suffix,
    accountEmail: email,
    accountPhone: phone
  } = {},
  isSocialLogin,
  loading,
  onClickEdit
}) => {
  const classes = useStyles();
  const account = {
    name: formatName(firstName, middleName, lastName, suffix),
    phone,
    email,
    password: !loading && '********'
  };

  return (
    <section className={classes.card}>
      <Grid
        alignItems="center"
        container
        justifyContent="flex-start"
        spacing={2}
      >
        <Grid item xs>
          <Typography variant="body1" component="h2">
            Holder
          </Typography>
        </Grid>
        <Grid item xs align="right">
          <Button
            color="Wisdom"
            size="medium"
            variant="ghost"
            onClick={onClickEdit}
          >
            Edit
          </Button>
        </Grid>
      </Grid>
      <Divider className={classes.divider} aria-hidden />
      <Grid
        alignItems="center"
        className={classes.list}
        component="dl"
        container
        justifyContent="flex-start"
        spacing={2}
      >
        {fields.map(({ key, label }) => (
          !(isSocialLogin && key === 'password') && (
            <Grid
              className={classes.listItem}
              component="div"
              data-testid={key}
              item
              key={key}
              sm={6}
              xs={12}
            >
              <Typography className={classes.boldText} component="dt" variant="h4">
                {label}
              </Typography>
              <Typography className={classes.bodyText} color="textSecondary" component="dd" noWrap variant="body2">
                {loading ? (<Skeleton width="80%" />) : account[key]}
              </Typography>
            </Grid>
          )))}
      </Grid>
    </section>
  );
};

AccountHolder.propTypes = {
  account: PropTypes.shape({}).isRequired,
  isSocialLogin: PropTypes.bool.isRequired,
  loading: PropTypes.bool,
  onClickEdit: PropTypes.func.isRequired
};

export default AccountHolder;
